const getters = {
    departments: state => state.departments,
    departmentList: state => state.department_list,
    department: state => state.department,
    parentDepartments: state => state.parent_departments,
}

export default getters;
